(() => {
  const money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });

  const number = (value, fallback = 0) => {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const nextNinetyNine = (value) => {
    const whole = Math.floor(value);
    const candidate = whole + 0.99;
    return Math.max(0.99, candidate + 0.000001 >= value ? candidate : whole + 1.99);
  };

  const reference = () => {
    const date = new Date();
    const stamp = [String(date.getFullYear()).slice(-2), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('');
    const random = Math.random().toString(36).slice(2, 6).toUpperCase();
    return `FSQ-${stamp}-${random}`;
  };

  document.querySelectorAll('[data-custom-quote]').forEach((root) => {
    const unit = root.querySelector('[data-quote-unit]');
    const length = root.querySelector('[data-quote-length]');
    const width = root.querySelector('[data-quote-width]');
    const depth = root.querySelector('[data-quote-depth]');
    const foam = root.querySelector('[data-quote-foam]');
    const cover = root.querySelector('[data-quote-cover]');
    const quantity = root.querySelector('[data-quote-quantity]');
    const calculate = root.querySelector('[data-quote-calculate]');
    const error = root.querySelector('[data-quote-error]');
    const consent = root.querySelector('[data-quote-consent]');
    const submit = root.querySelector('[data-quote-submit]');
    let calculated = false;

    const updateSubmit = () => {
      submit.disabled = !(calculated && consent.checked);
      submit.textContent = calculated ? (consent.checked ? 'Request written quote' : 'Accept the acknowledgement to continue') : 'Calculate first to request quote';
    };

    const invalidate = () => {
      calculated = false;
      updateSubmit();
    };

    [unit, length, width, depth, foam, cover, quantity].forEach((field) => field.addEventListener('input', invalidate));
    consent.addEventListener('change', updateSubmit);

    calculate.addEventListener('click', () => {
      const enteredLength = number(length.value);
      const enteredWidth = number(width.value);
      const enteredDepth = number(depth.value);
      const itemQuantity = Math.floor(number(quantity.value));

      if (enteredLength <= 0 || enteredWidth <= 0 || enteredDepth <= 0 || itemQuantity < 1 || itemQuantity > 50) {
        error.textContent = 'Enter positive measurements and a quantity between 1 and 50.';
        error.hidden = false;
        return;
      }

      error.hidden = true;
      const conversion = unit.value === 'mm' ? 1 / 25.4 : (unit.value === 'cm' ? 1 / 2.54 : 1);
      const lengthInches = enteredLength * conversion;
      const widthInches = enteredWidth * conversion;
      const depthInches = enteredDepth * conversion;
      const selectedFoam = foam.options[foam.selectedIndex];
      const materialRate = number(selectedFoam.dataset.rate);

      let coverCost = 0;
      const longestSide = Math.max(lengthInches, widthInches);
      if (cover.value === 'mattress') {
        coverCost = number(root.dataset.coverMattress);
      } else if (cover.value === 'mattress-water') {
        coverCost = number(root.dataset.coverMattressWater);
      } else if (cover.value !== 'none') {
        if (longestSide <= 20) coverCost = number(root.dataset.coverSmall);
        else if (longestSide <= 35) coverCost = number(root.dataset.coverMedium);
        else if (longestSide <= 50) coverCost = number(root.dataset.coverLarge);
        else coverCost = number(root.dataset.coverXlarge);
        if (cover.value === 'water-resistant') coverCost += number(root.dataset.coverUpgrade);
      }

      const materialCostEach = (lengthInches * widthInches * depthInches / 144) * materialRate;
      const supplierCostExVatEach = materialCostEach + coverCost + number(root.dataset.packingCost);
      const totalCostExVat = supplierCostExVatEach * itemQuantity;
      const vatRate = number(root.dataset.vatRate) / 100;
      const profitMarkup = number(root.dataset.profitMarkup) / 100;
      const percentageFee = number(root.dataset.shopifyPercent) / 100;
      const fixedFee = number(root.dataset.shopifyFixed);
      const denominator = 1 - percentageFee;

      if (denominator <= 0) {
        error.textContent = 'The pricing settings need review. Please contact FOAMSUPA for a manual quote.';
        error.hidden = false;
        return;
      }

      const grossBeforeShopifyFees = totalCostExVat * (1 + profitMarkup) * (1 + vatRate);
      const rawGrossTotal = (grossBeforeShopifyFees + fixedFee) / denominator;
      const grossTotal = nextNinetyNine(rawGrossTotal);
      const quoteReference = reference();
      const coverLabel = cover.options[cover.selectedIndex].text;
      const specification = [
        `Reference: ${quoteReference}`,
        `Measurements: ${enteredLength} × ${enteredWidth} × ${enteredDepth} ${unit.value}`,
        `Foam: ${selectedFoam.text}`,
        `Finish: ${coverLabel}`,
        `Quantity: ${itemQuantity}`,
        `Approximate product total including VAT: ${money.format(grossTotal)}`,
        'Delivery: not included; to be quoted after product quote approval.'
      ].join('\n');

      root.querySelector('[data-quote-reference]').textContent = quoteReference;
      root.querySelector('[data-quote-total]').textContent = money.format(grossTotal);
      root.querySelector('[data-quote-unit-price]').textContent = money.format(grossTotal / itemQuantity);
      root.querySelector('[data-quote-result-quantity]').textContent = itemQuantity;
      root.querySelector('[data-quote-form-reference]').value = quoteReference;
      root.querySelector('[data-quote-form-price]').value = money.format(grossTotal);
      root.querySelector('[data-quote-form-specification]').value = specification;
      root.querySelector('[data-quote-empty]').hidden = true;
      root.querySelector('[data-quote-result]').hidden = false;

      calculated = true;
      updateSubmit();
    });

    updateSubmit();
  });
})();
